import { TFunction } from 'i18next';

export const getLoyaltyPointsText = (
  promotion: { dollarCap: number | null, pointCap: number | null },
  t: TFunction,
) => {
  return promotion.dollarCap
    ? t($ => $.promotions.loyaltyPoints.liabilityWithCap, {
      amount: promotion.dollarCap,
      points: promotion.pointCap,
    })
    : t($ => $.promotions.loyaltyPoints.pointsOnly, { points: promotion.pointCap });
};

export const getPointsCapProgressText = (
  promotion: { pointsAwarded: number | null, pointCap: number | null },
  t: TFunction,
) => {
  if (!promotion.pointCap) {
    return '';
  }
  const percent = ((promotion.pointsAwarded ?? 0) / promotion.pointCap) * 100;
  return t($ => $.promotions.loyaltyPoints.capReached, { amount: percent });
};
